/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, OnDestroy, ViewChild, ChangeDetectionStrategy, Input } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PlanState } from 'src/app/services/plan-state.service';
import { CustomFieldEditorComponent } from './custom-field-editor.component';

@Component({
	selector: 'custom-field-starter',
	template: '',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomFieldStarterComponent implements OnDestroy {
	constructor(private dialog: MatDialog, private planState: PlanState) {
		this.openCustomFieldDialog();
	}

	public ngOnDestroy(): void {}

	public openCustomFieldDialog(): void {
		const data = {
			project: this.planState.project,
			rolesApi: this.planState.rolesApi,
			customFieldsApi: this.planState.customFieldsApi,
			isAdmin: true, //TODO: decide on this when implementing the designed behaviors for both admin and non-admin
		};

		this.dialog.open(CustomFieldEditorComponent, this.getDialogConfig(data));
	}

	private getDialogConfig(data: object): MatDialogConfig {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.disableClose = true;
		dialogConfig.autoFocus = true;
		dialogConfig.data = data;

		return dialogConfig;
	}
}
